module.exports = __webpack_public_path__ + "static/media/5.9651aded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobileOmBoarding/5.png
// module id = 934
// module chunks = 21